<template>
  <section v-if="hotDomains.length > 0" class="content-section" style="background: #ffffff;">
    <div class="content-inner">
      <div class="section-title">
        <div class="title-main">POPULAR DOMAINS</div>
        <div class="title-sub">热门域名 <span class="slash">//</span> HOT LIST</div>
      </div>

      <div class="domain-grid">
        <div
          v-for="domain in hotDomains.slice(0, 8)"
          :key="domain.id"
          class="domain-card"
        >
          <div class="domain-name">{{ domain.url }}</div>
          <div class="domain-meta">{{ domain.buy_count }} 人已选购</div>
          <a href="/user" class="domain-btn">立即选购</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { hotDomains } from '../data/data.js'
</script>
